import { useCallback } from 'react'
import { ApolloError } from '@apollo/client'
import { BannerContent } from 'features/StoryblokContent/BannerContent'

import { useOverviewBannerVisibility } from './hooks/useOverviewBannerVisibility/useOverviewBannerVisibility'

interface OverviewBannerProps {
  isLoading?: boolean
  error?: ApolloError
}

export const OverviewBanner = ({ isLoading, error }: OverviewBannerProps) => {
  const { isBannerHidden, setIsOverviewBannerHidden } =
    useOverviewBannerVisibility()

  const hideOverviewBanner = useCallback(() => {
    setIsOverviewBannerHidden(true)
  }, [setIsOverviewBannerHidden])

  if (isLoading || error || isBannerHidden) {
    return null
  }

  return (
    <BannerContent
      hideOverviewBanner={hideOverviewBanner}
      slug="dashboard-topline-banner-invoices-april"
    />
  )
}
